import React, { useEffect } from 'react';
import './Products.css';
import CustomHeader from '../components/layout/CustomHeader';
import CustomFooter from '../components/layout/CustomFooter';

const Products = () => {
  useEffect(() => {
    // Add scroll animations
    const animateOnScroll = () => {
      const cards = document.querySelectorAll('.product-card');
      const triggerHeight = window.innerHeight * 0.8;

      cards.forEach(card => {
        const cardTop = card.getBoundingClientRect().top;
        if (cardTop < triggerHeight) {
          card.style.opacity = '1';
          card.style.transform = 'translateY(0)';
        }
      });
    };

    // Add parallax effect to floating shapes
    const handleScroll = () => {
      const scrolled = window.pageYOffset;
      const shapes = document.querySelectorAll('.shape');
      
      shapes.forEach((shape, index) => {
        const speed = (index + 1) * 0.5;
        shape.style.transform = `translateY(${scrolled * speed}px)`;
      });
    };

    // Add hover effects for cards
    const cards = document.querySelectorAll('.product-card');
    cards.forEach(card => {
      card.addEventListener('mouseenter', () => {
        card.style.background = 'rgba(255, 255, 255, 1)';
      });
      
      card.addEventListener('mouseleave', () => {
        card.style.background = 'rgba(255, 255, 255, 0.95)';
      });
    });

    window.addEventListener('scroll', animateOnScroll);
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('load', animateOnScroll);

    return () => {
      window.removeEventListener('scroll', animateOnScroll);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Interactive functions
  const showInquiry = (product) => {
    alert(`Thank you for your interest in our ${product}! Our team will contact you shortly to schedule a personalized demo and discuss your requirements.`);
  };

  const showFeatures = (product) => {
    const features = {
      'LMS': 'Our LMS includes advanced features like AI-powered content recommendations, plagiarism detection, collaborative learning spaces, and comprehensive reporting dashboards.',
      'School Management': 'Key features include cloud-based data storage, multi-language support, customizable report generation, and seamless integration with existing school systems.',
      'Vehicle Servicing': 'Advanced features include GPS tracking, inventory management for spare parts, customer loyalty programs, and integration with automotive diagnostic tools.'
    };
    alert(`${product} Advanced Features:\n\n${features[product]}`);
  };

  const showContactForm = () => {
    alert('Contact Form will open here. You can integrate this with your preferred contact form solution or CRM system.');
  };

  return (
    <>
      <CustomHeader activePage="products" />

      <div className="floating-shapes">
        <div className="shape"></div>
        <div className="shape"></div>
        <div className="shape"></div>
      </div>

      <div className="header">
        <div className="container">
          <h1>IntelUniVen Products</h1>
          <p>Cutting-edge solutions designed to transform your business operations and enhance user experiences across education, management, and automotive services.</p>
        </div>
      </div>

      <div className="container">
        <div className="products-grid">
          {/* LMS Product Card */}
          <div className="product-card">
            <div className="product-icon">📚</div>
            <h2 className="product-title">Learning Management System</h2>
            <p className="product-description">
              A comprehensive digital learning platform that revolutionizes education delivery and student engagement through interactive content and advanced analytics.
            </p>
            <ul className="features-list">
              <li>Interactive course creation and multimedia integration</li>
              <li>Real-time progress tracking and analytics dashboard</li>
              <li>Virtual classroom with video conferencing</li>
              <li>Automated grading and assessment tools</li>
              <li>Mobile-responsive design for anywhere learning</li>
              <li>Integration with external tools and APIs</li>
            </ul>
            <div className="cta-buttons">
              <a href="#" className="btn btn-primary" onClick={() => showInquiry('LMS')}>Get Demo</a>
              <a href="#" className="btn btn-secondary" onClick={() => showFeatures('LMS')}>View Features</a>
            </div>
          </div>

          {/* School Management App */}
          <div className="product-card">
            <div className="product-icon">🏫</div>
            <h2 className="product-title">School Management App</h2>
            <p className="product-description">
              An all-in-one solution that streamlines school operations, from student enrollment to staff management, creating seamless communication between all stakeholders.
            </p>
            <ul className="features-list">
              <li>Student information and attendance management</li>
              <li>Fee collection and financial reporting</li>
              <li>Parent-teacher communication portal</li>
              <li>Timetable and exam scheduling</li>
              <li>Staff payroll and HR management</li>
              <li>Transport and hostel management</li>
            </ul>
            <div className="cta-buttons">
              <a href="#" className="btn btn-primary" onClick={() => showInquiry('School Management')}>Get Demo</a>
              <a href="#" className="btn btn-secondary" onClick={() => showFeatures('School Management')}>View Features</a>
            </div>
          </div>

          {/* Vehicle Servicing App */}
          <div className="product-card">
            <div className="product-icon">🚗</div>
            <h2 className="product-title">Vehicle Servicing App</h2>
            <p className="product-description">
              A smart automotive service platform that connects vehicle owners with certified mechanics, offering convenient booking, tracking, and maintenance solutions.
            </p>
            <ul className="features-list">
              <li>Online booking and service scheduling</li>
              <li>Real-time service tracking and updates</li>
              <li>Digital service history and maintenance records</li>
              <li>Multi-payment gateway integration</li>
              <li>Mechanic rating and review system</li>
              <li>Emergency roadside assistance feature</li>
            </ul>
            <div className="cta-buttons">
              <a href="#" className="btn btn-primary" onClick={() => showInquiry('Vehicle Servicing')}>Get Demo</a>
              <a href="#" className="btn btn-secondary" onClick={() => showFeatures('Vehicle Servicing')}>View Features</a>
            </div>
          </div>
        </div>
      </div>

      <div className="contact-section">
        <div className="container">
          <h2>Ready to Transform Your Business?</h2>
          <p>Let's discuss how our solutions can be customized for your specific needs</p>
          <button className="contact-btn" onClick={showContactForm}>Start Your Journey</button>
        </div>
      </div>

      <CustomFooter />
    </>
  );
};

export default Products; 